"use strict";
/**
 * Created on 07 22 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var MasterAreaDeactivatedNotification_1 = require("../../model/notifications/MasterAreaDeactivatedNotification");

var MasterAreaDeactivatedNotificationConverter_1 = require("./MasterAreaDeactivatedNotificationConverter");
/**
 * <p>Implementation of {@link MasterAreaDeactivatedNotificationConverter}.</p>
 *
 * @author JMe
 */


var MasterAreaDeactivatedNotificationConverterImpl =
/*#__PURE__*/
function (_MasterAreaDeactivate) {
  _inherits(MasterAreaDeactivatedNotificationConverterImpl, _MasterAreaDeactivate);

  function MasterAreaDeactivatedNotificationConverterImpl() {
    _classCallCheck(this, MasterAreaDeactivatedNotificationConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(MasterAreaDeactivatedNotificationConverterImpl).apply(this, arguments));
  }

  _createClass(MasterAreaDeactivatedNotificationConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, {
        pIdToAreaIds: conversions.asKeyValuePairs(source, 'pIdToAreaIds', function (pId) {
          return conversions.toDocumentReferenceId(pId);
        }, function (areaIds) {
          return areaIds.map(function (areaId) {
            return conversions.toDocumentReferenceId(areaId);
          }).toArray();
        })
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new MasterAreaDeactivatedNotification_1.MasterAreaDeactivatedNotification(conversions.asMap(source, 'pIdToAreaIds', function (pId) {
        return conversions.toClassReferenceId(pId);
      }, function (areaIds) {
        return immutable_1.Set(areaIds.map(function (areaId) {
          return conversions.toClassReferenceId(areaId);
        }));
      }));
    }
  }]);

  return MasterAreaDeactivatedNotificationConverterImpl;
}(MasterAreaDeactivatedNotificationConverter_1.MasterAreaDeactivatedNotificationConverter);

exports.MasterAreaDeactivatedNotificationConverterImpl = MasterAreaDeactivatedNotificationConverterImpl;
/**
 * Qualifier for IoC
 */

MasterAreaDeactivatedNotificationConverterImpl.QUALIFIER = {
  documentType: MasterAreaDeactivatedNotification_1.MasterAreaDeactivatedNotification.DOCUMENT_TYPE
};